import { Component, h, Host, Prop } from '@stencil/core';
import { SearchResultItem } from '~model/search-result-item';
import { Translate } from '~service/translation-service';

@Component({
  tag: 'staedtler-search-result-item-article',
})
export class SearchResultItemArticle {
  @Prop() item: SearchResultItem;

  render() {
    const pictureClass = {
      'has-play': this.item.showVideoIcon,
    };
    const newFlag = this.isNew ? <span class="teaser-tag">{Translate.translate('search.result.new')}</span> : '';
    return (
      <Host class={'staedtler-search-result-item teaser teaser-s'}>
        <a href={this.item.url}>
          <picture class={pictureClass} aria-describedby={'staedtler-search-result-item-article-' + this.item.id}>
            <source srcSet={this.item.teaserImage[1200]} media="(min-width: 1200px)" />
            <source srcSet={this.item.teaserImage[992]} media="(min-width: 992px)" />
            <source srcSet={this.item.teaserImage[768]} media="(min-width: 768px)" />
            <source srcSet={this.item.teaserImage[576]} media="(min-width: 576px)" />
            <source srcSet={this.item.teaserImage[1]} />
            <img src={this.item.teaserImage.thumbnail} loading="lazy" decoding="async" title={this.item.title} width="360" height="240" class="img-fluid" />
          </picture>
          <span class="teaser-content" id={'staedtler-search-result-item-article-' + this.item.id}>
            {newFlag}
            {this.item.title}
          </span>
        </a>
      </Host>
    );
  }

  get isNew() {
    if (!this.item) {
      return false;
    }
    if (!this.item.newUntil) {
      return false;
    }

    return new Date(this.item.newUntil) > new Date();
  }
}
